/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { JsonFormsDispatch, useJsonForms } from '@jsonforms/react';
import { getEndpointName, getHeaders } from '@apollo/jsonforms-react-spectrum-renderers/src/util/commonUtils';
import Pagination from '../../components/Pagination/Pagination';
import { calculateTotalPage, getPerPageItems, removeStyleAttributes } from './utils';
import '../../components/Pagination/css/Pagination.module.scss';

function PaginationWrapper(props: any) {
  const {
    paginationProps, pagination,
    data,
    dataComponentProps,
    dataComponent: DataComponent,
    paginationFromServer,
    paginationApiConfig,
  } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(paginationProps.paginationPerPage);
  const [tableData, setTableData] = useState([]) as any[];
  const [pageSizeList, setpageSizeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tableError, setTableError] = useState(null) as any;
  const [headersLoaded, setHeadersLoaded] = useState(false);
  // const [totalRecords, setTotalRecords] = useState(0) as any;
  const { renderers, cells, config } = useJsonForms();

  const dataUrl = paginationApiConfig?.dataUrl;
  const currentPagedataKey = paginationApiConfig?.currentPagedataKey;
  const totalDataLengthKey = paginationApiConfig?.totalDataLengthKey;

  const fetchCurrentPageDataFromApi = async (paramValue: any) => {
    const dataUrlKeys = ['pageNumber', 'pageSize'];
    const endpointPath = paginationApiConfig?.endpointPath;
    /* option to provide any additional data to header  */
    const additionalHeaders = paginationApiConfig?.additionalHeaders;
    const authToken = paginationApiConfig.authToken || false;

    /** merges headers with additional headers if defined  */
    const apiHeaders = additionalHeaders
      ? _.unionBy(additionalHeaders, config?.apiHeaders, "name")
      : config?.apiHeaders;
    const headers = getHeaders(apiHeaders);

    let apiEndPoint = '';
    // if dataUrl has dynamic keys then append here
    // eg: 'v1/${workspace}/connector/${id}' => 'v1/workspace-id-here/connector/id-here'

    dataUrlKeys.forEach((item: any) => {
      apiEndPoint =
        item && paramValue[item]
          ? dataUrl.replace(`\${${item}}`, paramValue[item])
          : dataUrl;
    });

    // if API need Authorization Token But session storage is loading after page Load.
    if (authToken) {
      if (headers.get("Authorization") && !headersLoaded) {
        setHeadersLoaded(true);
      }
    } else if (!headersLoaded) {
      setHeadersLoaded(true);
    }

    if (endpointPath) {
      const pathKey = getEndpointName(endpointPath, config);
      const endpoint = _.get(config, pathKey, "");
      apiEndPoint = endpoint + dataUrl;
    }

    headers.append("content-type", "application/json;charset=UTF-8");
    const fetchParams = {
      method: "GET",
      headers,
    };

    await fetch(apiEndPoint, fetchParams)
      .then(async (response) => {
        if (response.ok) {
          const resData = await response.json();
          return { currentPageData: resData[currentPagedataKey], totalRecords: resData[totalDataLengthKey] };
        }
        if (!response.ok) {
          setTableError('Current page data fetch Pagination API falied');
        }
        return {};
      })
      .catch((error) => {
        console.log(error);
        setTableError('Current page data fetch Pagination API falied');
      })
    return {};
  }

  useEffect(() => {
    const { paginationPerPage, paginationRowsPerPageOptions } = paginationProps;
    if (paginationPerPage) {
      if (paginationRowsPerPageOptions) {
        setpageSizeList(paginationRowsPerPageOptions.map(
          (item: any) => ({ "id": item, "name": item.toString() })
        ))
      }
      setCurrentPageSize(paginationPerPage);
    }
  }, [paginationProps.paginationRowsPerPageOptions, paginationProps.paginationPerPage])

  useEffect(() => {
    if (data) {
      if (pagination) {
        if (!paginationFromServer) {
          setTableData(getPerPageItems(data, 1, currentPageSize));
          setTotalPageCount(calculateTotalPage(data.length, currentPageSize));
        }
        setCurrentPage(1);
      }
      else {
        setTableData(data);
      }
    }
  }, [data, paginationFromServer])

  /**
 * set page state to the page number and
 * get the opportunities based on that
 * @param {Number} pageNo page number
 */
  const handlePageChange = async (pageNo: any) => {
    //  get table data required for per page based on the limit
    if (!paginationFromServer) setTableData(getPerPageItems(data, pageNo, currentPageSize));
    if (paginationFromServer) {
      setLoading(true);
      let resultData: any = {};
      resultData = await fetchCurrentPageDataFromApi({ pageSize: currentPageSize, pageNumber: pageNo });
      setTableData(resultData.currentPageData);
      setLoading(false);
    }
    setCurrentPage(pageNo);
    // remove any style attributes added during flexible columns
    removeStyleAttributes();
  }

  /**
* set the page size and
* get the opportunities based on that
* @param size page size
*/
  const onPageSizeChange = async (size: any) => {
    if (!paginationFromServer) {
      setTableData(getPerPageItems(data, 1, size));
      setTotalPageCount(calculateTotalPage(data.length, size));
    }
    let resultData: any = {};
    if (paginationFromServer) {
      setLoading(true);
      resultData = await fetchCurrentPageDataFromApi({ pageSize: size, pageNumber: 1 });
      setTableData(resultData.currentPageData);
      if (resultData.totalRecords) setTotalPageCount(calculateTotalPage(resultData.totalRecords, size));
      setLoading(false);
    }
    setCurrentPageSize(size);
    setCurrentPage(1)
    // remove any style attributes added during flexible columns
    removeStyleAttributes();
  }

  useEffect(() => {
    if (paginationFromServer) {
      const { paginationPerPage } = paginationProps;
      onPageSizeChange(paginationPerPage);
    }
  }, [])

  const paginationComponent = () => <div id="customPagination">
    <JsonFormsDispatch
      renderers={renderers}
      cells={cells}
      {...paginationProps.paginationCustomComponentJson}
      config={{
        ...config,
        page: currentPage,
        totalPageCount,
        sizeList: pageSizeList,
        size: currentPageSize,
        onPageChange: handlePageChange,
        onPageSizeChange,
        ...paginationProps,
      }}
    />
  </div>

  return (
    <div>
      <DataComponent
        {...dataComponentProps}
        data={tableData && tableData}
        progressPending={loading}
        noDataComponent={tableError || dataComponentProps.noDataComponent}
      />
      {pagination && !paginationProps?.paginationCustomComponentJson && <Pagination
        page={currentPage}
        totalPageCount={totalPageCount}
        sizeList={pageSizeList}
        size={currentPageSize}
        onPageChange={handlePageChange}
        onPageSizeChange={onPageSizeChange}
        {...paginationProps}
      />}
      {
        pagination && paginationProps.paginationCustomComponentJson && paginationComponent()
      }
    </div>
  );
}

export default PaginationWrapper;